export default __webpack_public_path__ + "static/epilogue-b74d2f37ad674ab79bcb8b95d7c26741.svg";